import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './style';

class SelectList extends React.Component {
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  getHightLightText = (value, hightlight) => {
    return value.substr(
      value.toLocaleLowerCase().indexOf(hightlight.toLocaleLowerCase()),
      hightlight.length
    );
  };

  getValue = item => {
    const { hightlight } = this.props;
    let value = item.name;
    /* eslint-disable */
    if (hightlight) {
      const hightLightText = this.getHightLightText(value, hightlight);
      const text = `<strong>${hightLightText}</strong>${value.substr(hightLightText.length)}`;
      value = <span dangerouslySetInnerHTML={{ __html: text }} />;
    }
    /* eslint-enable */
    return value;
  };

  handleClickOutside = event => {
    const { wrapperRef, isDroppedDown, onSelect } = this.props;
    if (wrapperRef && isDroppedDown && !wrapperRef.contains(event.target)) {
      onSelect();
    }
  };

  onClick = selected => {
    const { onSelect } = this.props;
    onSelect(selected);
  };

  renderList = list => {
    const { listStyle } = this.props;
    return (
      <div>
        <ul style={listStyle}>
          {list.map((item, i) => {
            return (
              <li key={i} id={item.id} onClick={() => this.onClick(item)}>
                {this.getValue(item)}
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

  render() {
    const { showSelected, toggleSelect, isDroppedDown, selected, list } = this.props;
    return (
      <styles.SelectList
        id="select-list-component"
        showSelected={showSelected}
        onClick={toggleSelect ? () => toggleSelect(!isDroppedDown) : null}
      >
        {showSelected && (
          <React.Fragment>
            {selected.name}
            <styles.Caret />
          </React.Fragment>
        )}
        {isDroppedDown ? this.renderList(list) : null}
      </styles.SelectList>
    );
  }
}

SelectList.propTypes = {
  list: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
  selected: PropTypes.object,
  hightlight: PropTypes.string,
  isDroppedDown: PropTypes.bool.isRequired,
  showSelected: PropTypes.bool,
  listStyle: PropTypes.object.isRequired,
  toggleSelect: PropTypes.func.isRequired,
  wrapperRef: PropTypes.object.isRequired,
};

SelectList.defaultProps = {
  list: [],
  selected: {},
  hightlight: '',
  showSelected: true,
};

export default SelectList;



// WEBPACK FOOTER //
// ./src/components/SelectList/index.js